import { MarkDownPage } from '@shared/layout/MarkDownPage'

const UserAgreementText = `
## Оглавление
 
1. Общие положения
2. Сбор и обработка персональных данных
3. Цели обработки персональных данных] 
4. Раскрытие персональных данных  
5. Защита персональных данных  
6. Права пользователей  
7. Обработка биометрических данных  
8. Управление файлами cookie  
9. Хранение данных  
10. Изменения в Политике конфиденциальности  
11. Контактная информация  
 
---
 
## Общие положения
 
1. Настоящая Политика конфиденциальности (далее — «Политика») разработана в соответствии с Федеральным законом № 152-ФЗ «О персональных данных» и другими нормативными актами Российской Федерации.  
2. Политика регулирует порядок обработки персональных данных Пользователей приложения TISIT (далее — «Приложение»).  
3. Используя Приложение, Пользователь выражает согласие с настоящей Политикой.  
4. В случае несогласия с условиями Политики Пользователь обязан прекратить использование Приложения.  
 
---
 
## Сбор и обработка персональных данных
 
1. Компания собирает следующие категории данных:  
   - Идентификационные данные: имя, номер телефона, email.  
   - Физические характеристики: возраст, пол, вес, рост.  
   - Медицинские данные: ограничения по здоровью (по согласованию).  
   - Биометрические данные: частота сердечных сокращений, данные фитнес-устройств.  
   - Автоматически собираемые данные: IP-адрес, местоположение (с разрешения), данные устройства.  
2. Данные собираются:  
   - При регистрации в Приложении.  
   - Через подключенные устройства (например, умные часы).  
   - С помощью файлов cookie.  
 
---
 
## Цели обработки персональных данных
 
1. Персональные данные обрабатываются для:  
   - Создания персонализированных тренировочных программ.  
   - Улучшения качества Приложения.  
   - Информирования Пользователей об обновлениях и акциях.  
2. Биометрические данные используются только для корректировки тренировок.  
 
---
 
## Раскрытие персональных данных
 
1. Компания обязуется не передавать данные третьим лицам, кроме случаев:  
   - Запроса государственных органов.  
   - Использования сторонних сервисов для выполнения обязательств (например, обработка платежей).  
   - Передачи обезличенных данных для аналитики.  
 
---
 
## Защита персональных данных
 
1. Компания принимает меры для защиты данных:  
   - Шифрование данных.  
   - Ограничение доступа сотрудников.  
   - Регулярное тестирование систем безопасности.  
2. В случае утечки данных Компания обязуется уведомить пострадавших Пользователей.  
 
---
 
## Права пользователей
 
Пользователь имеет право:  
- Получить информацию об обработке его данных.  
- Уточнить или удалить свои данные.  
- Отозвать согласие на обработку данных.  
 
---
 
## Обработка биометрических данных
 
1. Биометрические данные обрабатываются только с согласия Пользователя.  
2. Компания обязуется уничтожить данные в случае отзыва согласия в течение 30 календарных дней.  
 
---
 
## Управление файлами cookie
 
1. Cookie используются для анализа активности Пользователей.  
2. Пользователь может отключить cookie через настройки браузера, но это может ограничить функциональность Приложения.  
 
---
 
## Хранение данных
 
1. Данные хранятся не дольше, чем это необходимо для их обработки.  
2. По истечении срока данные уничтожаются или обезличиваются.  
 
---
 
## Изменения в Политике конфиденциальности
 
1. Компания оставляет за собой право изменять Политику.  
2. Изменения вступают в силу через 10 рабочих дней после уведомления Пользователей.  
 
---
 
## Контактная информация
 
- **Адрес**: 353564, Краснодарский край, Славянский район, г. Славянск-на-Кубани, ул. Школьная, д. 179  
- **Электронная почта**: info@tisit.club  
- **Телефон**: +7 (993) 302-90-56  

`

export const UserAgreement = () => {
	return <MarkDownPage text={UserAgreementText} />
}
